import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { GetDocStoreDetails } from "../ordersSummary/orderSummarySlice";
import { addSeconds } from "date-fns";

// initial state
export const initialState = {
  loadingInvoice: false,
  error: null,
  success: false,
  pricingInfo: null,
  invoices: null,
  assignedPolicies: null,
  firmInvoices: null,
  firmInvoicesTotal: null,
  invoiceLineDetails: null,
  invoiceTotals: null,
  lawyerFilterOptions: null,
  pastPayments: null,
  paymentInfoValue: null,
  PayInoviceCCDetails: [],
  diffCCDetails: [],
  isAllCCVaultKeysfetched: false,
  invoiceFilters: false,
  invoiceFilterValue: [],
  multipleInvoicePages: false,
  multiplePaymentsPages: false,
  selectedPastPayments: [],
  selectedOutstandingInvoices: []
};

// our slice
const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loadingInvoice = true;
    },
    setError: (state, { payload }) => {
      state.loadingInvoice = false;
      state.error = payload;
    },
    setSuccess: (state) => {
      state.loadingInvoice = false;
      state.error = false;
      state.success = true;
    },
    setPricingInfo: (state, { payload }) => {
      state.pricingInfo = payload;
    },
    setInvoices: (state, { payload }) => {
      state.invoices = payload;
    },
    setAssignedPolicies: (state, { payload }) => {
      state.assignedPolicies = payload;
    },
    setFirmInvoices: (state, { payload }) => {
      state.firmInvoices = payload;
    },
    setFirmInvoicesTotal: (state, { payload }) => {
      state.firmInvoicesTotal = payload;
    },
    setInvoiceDetails: (state, { payload }) => {
      state.invoiceLineDetails = payload;
    },
    setInvoiceTotals: (state, { payload }) => {
      state.invoiceTotals = payload;
    },
    setLawyerFilterOptions: (state, { payload }) => {
      state.lawyerFilterOptions = payload;
    },
    setPastPayments: (state, { payload }) => {
      state.pastPayments = payload;
    },
    setPaymentInfoValue: (state, { payload }) => {
      state.paymentInfoValue = payload;
    },
    setisAllCCVaultKeysfetched: (state, { payload }) => {
      state.isAllCCVaultKeysfetched = payload;
    },
    setPayInoviceCCDetails: (state, { payload }) => {
      if (payload === "empty") state.PayInoviceCCDetails = [];
      else if (Array.isArray(payload)) state.PayInoviceCCDetails = payload;
      else state.PayInoviceCCDetails = [...state.PayInoviceCCDetails, payload];
    },
    setdiffCCDetails: (state, { payload }) => {
      if (payload === "empty") state.diffCCDetails = [];
      else if (Array.isArray(payload)) state.diffCCDetails = payload;
      else state.diffCCDetails = [...state.diffCCDetails, payload];
    },
    setInvoiceFilters: (state, { payload }) => {
      state.invoiceFilters = payload;
    },
    setInvoiceFilterValue: (state, { payload }) => {
      state.invoiceFilterValue = payload;
    },
    setMultipleInvoicePages: (state, { payload }) => {
      state.multipleInvoicePages = payload;
    },
    setMultiplePaymentsPages: (state, { payload }) => {
      state.multiplePaymentsPages = payload;
    },
    setSelectedPastPayments: (state, { payload }) => {
      state.selectedPastPayments = payload;
    },
    setSelectedOutstandingInvoices: (state, { payload }) => {
      state.selectedOutstandingInvoices = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setPricingInfo,
  setInvoices,
  setAssignedPolicies,
  setFirmInvoices,
  setFirmInvoicesTotal,
  setInvoiceDetails,
  setInvoiceTotals,
  setLawyerFilterOptions,
  setPastPayments,
  setPaymentInfoValue,
  setPayInoviceCCDetails,
  setdiffCCDetails,
  setisAllCCVaultKeysfetched,
  setInvoiceFilters,
  setInvoiceFilterValue,
  setMultipleInvoicePages,
  setMultiplePaymentsPages,
  setSelectedPastPayments,
  setSelectedOutstandingInvoices
} = invoiceSlice.actions;

export const invoiceSelector = (state) => state.invoice;

// export the default reducer
export default invoiceSlice.reducer;

export const GetPricingInfo =
  (request, userid, { toast }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let req = { UserID: userid, RequestObject: request };

        const results = await http
          .post("/Invoice/GetPricingInfoExpress", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          if (results?.data?.responseObject?.pricingInfoItems?.length === 0) {
            toast("Couldn't fetch pricing details.", {
              type: "error",
            });
          } else {
            dispatch(setPricingInfo(results.data.responseObject));
          }

          dispatch(setSuccess());
        } else {
          toast("Couldn't fetch pricing details.", {
            type: "error",
          });
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.title
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const GetInvoices = (fileid, userid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = { UserID: userid, RequestObject: { fileID: fileid } };

    const results = await http
      .post("/Invoice/GetInvoicesExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setInvoices(results.data.responseObject?.invoicesResponse));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const CheckInvoinceExistsAndDownloadPolicies = (fileid, userid, { downloadPoliciesClick }) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = { UserID: userid, RequestObject: { fileID: fileid } };

    const results = await http
      .post("/Invoice/GetInvoicesExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0 && results.data.responseObject.invoicesResponse == null) {
      downloadPoliciesClick();
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};


export const DownloadPolicy = (request, userid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("/Invoice/DownloadPolicy", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(GetAssignedPoliciesByFileID(request.FileID, userid));
      //dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetAssignedPoliciesByFileID =
  (fileID, userid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = {
        FileID: fileID,
      };

      const results = await http
        .post("Order/GetAssignedPoliciesByFileID", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setAssignedPolicies(results?.data?.responseObject));
        setTimeout(() => {
          //doc gen will be taking time to create documents
          dispatch(GetDocStoreDetails(fileID, userid));
          dispatch(setSuccess());
        }, 5000); // 5000 milliseconds = 5 seconds
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetFirmInvoicesExpress = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let lawyer = data.Lawyer.toString() === "All" ? "-1" : data.Lawyer.toString();
    let req = {
      FirmID: data.FirmID,
      Paid: data.Paid,
      userID: data.userID,
      commercial: data.commercial || 2,
      Lawyer: (data.isLawyer && !data.isInternalUser)
        ? data.userID.toString()
        : lawyer || "-1",
      closeDate: data.closeDate || "",
      DateRangeStart: data.DateRangeStart || "",
      DateRangeEnd: data.DateRangeEnd || "",
      BillingType: data.BillingType || "",
      SelectedFilelanguage: data.SelectedFilelanguage || "",
      SearchText: data.SearchText || "",
      SortColumn: data.SortColumn || "",
      SortOrder: data.SortOrder || "",
      TotalRangeStart:
        data.TotalRangeStart || data.TotalRangeStart === 0
          ? data.TotalRangeStart
          : null,
      TotalRangeEnd: data.TotalRangeEnd || null,
      pageNumber: data.pageNumber || null,
    };

    const results = await http
      .post("Invoice/GetFirmInvoicesExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(
        setFirmInvoices(results?.data?.responseObject.firmInvoicesExpress)
      );
      dispatch(setSuccess());
      const numberOfPages = Math.ceil(
        results?.data?.responseObject.firmInvoicesExpress &&
        results?.data?.responseObject.firmInvoicesExpress?.length > 0 &&
        results?.data?.responseObject.firmInvoicesExpress[0]?.totalRows /
        results?.data?.responseObject.firmInvoicesExpress?.length
      );
      if (numberOfPages > 1) {
        dispatch(setMultipleInvoicePages(true));
      } else {
        dispatch(setMultipleInvoicePages(false));
      }
      // setTimeout(() => {//doc gen will be taking time to create documents
      //   dispatch(GetDocStoreDetails(fileID, userid));
      //   dispatch(setSuccess());
      // }, 5000); // 5000 milliseconds = 5 seconds
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetAllFirmInvoices = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FirmID: data.FirmID,
      Paid: data.Paid,
      userID: data.userID,
      commercial: data.commercial || 2,
      Lawyer: data.isLawyer
        ? data.userID.toString()
        : data.Lawyer.toString() || "-1",
      closeDate: data.closeDate || "",
      DateRangeStart: data.DateRangeStart || "",
      DateRangeEnd: data.DateRangeEnd || "",
      BillingType: data.BillingType || "",
      SelectedFilelanguage: data.SelectedFilelanguage || "",
      SearchText: data.SearchText || "",
      SortColumn: data.SortColumn || "",
      SortOrder: data.SortOrder || "",
      TotalRangeStart:
        data.TotalRangeStart || data.TotalRangeStart === 0
          ? data.TotalRangeStart
          : null,
      TotalRangeEnd: data.TotalRangeEnd || null,
      pageNumber: -1,
    };

    const results = await http
      .post("Invoice/GetFirmInvoicesExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      return results?.data?.responseObject.firmInvoicesExpress;

      // setTimeout(() => {//doc gen will be taking time to create documents
      //   dispatch(GetDocStoreDetails(fileID, userid));
      //   dispatch(setSuccess());
      // }, 5000); // 5000 milliseconds = 5 seconds
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetFirmInvoicesTotal = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      firmID: data.FirmID,
      paid: data.Paid,
      userID: data.userID,
      dealType: data.commercial || 2,
      lawyerID: (data.isLawyer && !data.isInternalUser)
        ? data.userID.toString()
        : data.Lawyer.toString() || "-1",
      dateRangeStart: data.DateRangeStart || "",
      dateRangeEnd: data.DateRangeEnd || "",
      billingType: data.BillingType || "",
      paymentMethod: data.paymentMethod || "",
      filelanguage: data.SelectedFilelanguage || "",
      searchText: data.SearchText || "",
      totalRangeStart:
        data.TotalRangeStart || data.TotalRangeStart === 0
          ? data.TotalRangeStart
          : null,
      totalRangeEnd: data.TotalRangeEnd || null,
    };

    const results = await http
      .post("Invoice/GetFirmInvoicesTotal", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setFirmInvoicesTotal(results?.data?.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetInvoiceDetailsByInvoiceID = (InvoiceID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      InvoiceID,
    };

    const results = await http
      .post("invoice/GetInvoiceDetailsByInvoiceID", request)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setInvoiceDetails(results?.data?.responseObject.invoiceDetails));
      dispatch(setSuccess());

      return results?.data?.responseObject.invoiceDetails;
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetInvoiceTotalsByInvoiceID = (InvoiceID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      InvoiceID,
    };

    const results = await http
      .post("invoice/GetInvoiceTotalsByInvoiceID", request)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setInvoiceTotals(results?.data?.responseObject.invoiceTotals));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetFileandAssociatedLawyerByAssistant =
  (AssistantID) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        AssistantID,
      };

      const results = await http
        .post("lawfirm/GetFileandAssociatedLawyerByAssistant", request)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(
          setLawyerFilterOptions(results?.data?.responseObject.lawyerDetails)
        );
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetReviewPayments = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      firmID: data.firmID,
      lawyerID: (data.isLawyer && !data.isInternalUser)
        ? data.userID?.toString()
        : data.lawyerID?.toString() || "-1",
      userID: data.userID,
      dateRangeStart: data.dateRangeStart || "",
      dateRangeEnd: data.dateRangeEnd || "",
      paymentMethod: data.paymentMethod || "",
      searchText: data.searchText || "",
      sortColumn: data.SortColumn || "",
      sortOrder: data.SortOrder || "",
      totalRangeStart:
        data.totalRangeStart || data.totalRangeStart === 0
          ? data.totalRangeStart
          : null,
      totalRangeEnd: data.totalRangeEnd || null,
      pageNumber: data.pageNumber || 1,
    };

    const results = await http
      .post("invoice/GetReviewPayments", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(
        setPastPayments(results?.data?.responseObject.reviewPaymentsList)
      );
      if (
        Math.ceil(
          results?.data?.responseObject.reviewPaymentsList &&
          results?.data?.responseObject.reviewPaymentsList?.length > 0 &&
          results?.data?.responseObject.reviewPaymentsList[0]?.totalRows /
          results?.data?.responseObject.reviewPaymentsList?.length
        ) > 1
      ) {
        dispatch(setMultiplePaymentsPages(true));
      } else {
        dispatch(setMultiplePaymentsPages(false));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetReviewPaymentsCombinedResults = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      firmID: data.firmID,
      lawyerID: data.isLawyer
        ? data.userID?.toString()
        : data.Lawyer?.toString() || "-1",
      userID: data.userID,
      dateRangeStart: data.DateRangeStart || "",
      dateRangeEnd: data.DateRangeEnd || "",
      paymentMethod: data.paymentMethod || "",
      searchText: data.searchText || "",
      sortColumn: data.SortColumn || "",
      sortOrder: data.SortOrder || "",
      totalRangeStart:
        data.TotalRangeStart || data.TotalRangeStart === 0
          ? data.TotalRangeStart
          : null,
      totalRangeEnd: data.TotalRangeEnd || null,
      pageNumber: -1,
      PaymentID: data?.PaymentID || "",
      PaymentType: data?.PaymentType || "",
    };

    const results = await http
      .post("invoice/GetReviewPaymentsCombinedResults", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      return results?.data?.responseObject.combinedResultsList;
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetCCtransactionInvoices =
  (userID, ccTransactionID) => async (dispatch) => {
    try {
      let req = {
        ccTransactionID,
        userID,
      };

      const results = await http
        .post("invoice/GetCCtransactionInvoices", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        return results?.data?.responseObject.cCtransactionInvoicesList;
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
export const GetEFTTransactionInvoices =
  (userID, eftBatchID) => async (dispatch) => {
    try {
      let req = {
        eftBatchID,
        userID,
      };

      const results = await http
        .post("invoice/GetEFTTransactionInvoices", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        return results?.data?.responseObject.eftTransactionInvoicesList;
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
export const GetChequeTransactionInvoices =
  (userID, chequeNumber) => async (dispatch) => {
    try {
      let req = {
        chequeNumber,
        userID,
      };

      const results = await http
        .post("invoice/GetChequeTransactionInvoices", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        return results?.data?.responseObject.chequeTransactionInvoicesList;
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
export const GetPreAuthorizedTransactionInvoices =
  (userID, invoiceID) => async (dispatch) => {
    try {
      let req = {
        invoiceID,
        userID,
      };

      const results = await http
        .post("invoice/GetPreAuthorizedTransactionInvoices", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        return results?.data?.responseObject.preAuthTransactionInvoicesList;
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };


export const EmailInvoiceDocument =
  (req, { toast }) => async (dispatch) => {
    try {
      const results = await http
        .post("invoice/EmailInvoiceDocument", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        if (results.data.responseObject.isSuccess) {
          toast("Email sent successfully!", { type: "success" });
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };